var exports = {
  "k": "x2b2fbebb--cf90f1--container",
  "x": "x2b2fbebb--cf90f1--button",
};

module.exports = exports;
